import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { Button, Grid, Paper } from "@mui/material";
import { compose } from "@reduxjs/toolkit";
import dayjs from "dayjs";
import React from "react";
import { connect } from "react-redux";
import { ButtonCompo } from "../../components/Comman/Button";
import LandingScreenHeader from "../../components/Comman/LandingScreenHeader";
import { withRouter } from "../../components/withRouter";
import endpoint from "../../config/endpoints";
import {
  savemsg,
  saveWarningMsg,
  serverMsg
} from "../../config/messageconstant";
import { getSalesExecutiveByUserType } from "../../Slice/salesExecutive.slice";
import { apiPost } from "../../utils/api_service";
import { showLoador, showNotification } from "../Landing/Landing.slice";
import { downloadExcel, downloadF } from "../PDF/PDFDownload";
import NewProductCreationImportPopUp from "./NewProductCreationImportPopUp";
const ExcelJS = require("exceljs");

class NewProductCreationImportExport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fromDate: dayjs(),
      toDate: dayjs(),
      salesTeam: "",
      searchValue: "",
      importPopUpFlag: false,
      validatedProductList: [],
      hasErrorRow: false,
    };

    this.tableStyles = {
      tabContainer: {
        display: "flex",
        marginBottom: "16px",
        borderBottom: "1px solid #E5F1F9",
      },
      tableWrapper: {
        maxHeight: "570px",
        overflowY: "auto",
        overflowX: "auto", // Enable horizontal scrolling
        width: "100%",
        border: "1px solid rgb(182, 186, 188)",
        borderRadius: "8px",
      },
      table: {
        minWidth: "2800px", // Minimum width to ensure all columns are visible
        width: "max-content", // Allow table to grow based on content
        borderCollapse: "collapse",
        tableLayout: "auto", // Auto layout for flexible column sizing
      },
      stickyHeader: {
        position: "sticky",
        top: 0,
        backgroundColor: "rgb(233, 240, 243)",
        zIndex: 10,
      },
      tab: {
        padding: "8px 16px",
        cursor: "pointer",
        color: "#333",
        fontSize: "14px",
        fontWeight: "500",
        transition: "color 0.2s ease-in-out",
      },
      activeTab: {
        color: "#1C4E80",
        borderBottom: "2px solid #1C4E80",
      },
      noData: {
        padding: "16px",
        textAlign: "center",
        fontSize: "14px",
        color: "#666",
      },
      tableContainer: {
        backgroundColor: "#fff",
        borderRadius: "10px",
        padding: "16px",
        maxWidth: "100%", // Allow full width usage
        margin: "0 auto",
        boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
      },
      searchContainer: {
        marginBottom: "16px",
        display: "flex",
        alignItems: "center",
        maxWidth: "300px",
      },
      headerRow: {
        backgroundColor: "rgb(233, 240, 243)",
        color: "#000",
        fontWeight: "bold",
        fontSize: "14px",
      },
      headerCell: {
        padding: "12px 8px", // Reduced horizontal padding for better space utilization
        textAlign: "center",
        borderBottom: "2px solid #E5F1F9",
        borderRight: "1px solid #E5F1F9", // Add right border for better column separation
        fontWeight: 600,
        whiteSpace: "nowrap", // Prevent text wrapping in headers
        position: "sticky",
        top: 0,
        backgroundColor: "rgb(233, 240, 243)",
      },
      dataRow: {
        backgroundColor: "#fff",
        transition: "background-color 0.2s ease-in-out",
      },
      dataRowHover: {
        backgroundColor: "#E5F1F9",
      },
      dataCell: {
        padding: "12px 8px", // Reduced horizontal padding
        fontSize: "13px",
        color: "#333",
        borderBottom: "1px solid #E5F1F9",
        borderRight: "1px solid #E5F1F9", // Add right border for better column separation
        whiteSpace: "nowrap", // Prevent text wrapping
        overflow: "hidden",
        textOverflow: "ellipsis", // Show ellipsis for long text
      },
      amountCell: {
        color: "#004969",
        fontWeight: "500",
        fontSize: "13px",
      },
      alternateRow: {
        backgroundColor: "#fff",
      },
      searchInput: {
        width: "100%",
        padding: "8px 12px",
        fontSize: "14px",
        border: "1px solid #E5F1F9",
        borderRadius: "6px",
        outline: "none",
        color: "#333",
        transition: "border-color 0.3s ease-in-out",
      },
      searchInputFocus: {
        borderColor: "#1C4E80",
        boxShadow: "0 0 5px rgba(28, 78, 128, 0.3)",
      },
    };
  }

  onClickOfExport = () => {
    const { showLoador, showNotification } = this.props;

    showLoador({ loador: true });
    downloadF({
      isGet: true,
      url: endpoint.exportData + "/product-rate-structure-export-excel",
      ext: "xls",
      openNewTab: false,
    }).then((response) => {
      showLoador({ loador: false });
      if (!response) {
        showNotification({
          msg: serverMsg,
          severity: "error",
        });
      }
    });
  };

  onClickOfImport = () => {
    this.setState({ importPopUpFlag: true });
  };

  onSearchBox = (e) => {
    this.setState({
      searchValue: e.target.value,
    });
  };

  getFilteredTableData = (searchData) => {
    const { searchValue } = this.state;

    return searchData.filter((currentRow) => {
      let isValid = false;

      let productCode = currentRow?.productRateStructDetail[0]?.productCode;
      let ProductName = currentRow?.product?.name;

      if (
        (productCode &&
          productCode
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (ProductName &&
          ProductName.toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase()))
      ) {
        isValid = true;
        return true;
      }
    });
  };

  onSubmit = () => {
    const { showLoador, showNotification } = this.props;
    const { validatedProductList } = this.state;

    let dataToSendList =
      validatedProductList.length !== 0 ? validatedProductList : [];

    swal({
      title: "Are you sure?",
      text: saveWarningMsg,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        showLoador({ loador: true });
        apiPost({
          url: endpoint.importData + "/validated-product-rate-struct-data",
          postBody: dataToSendList,
        }).then(({ data, success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({
              msg: serverMsg,
              severity: "error",
            });
          } else {
            if (data && data.data && data.data.statusCode == 500) {
              showNotification({
                msg: data.data.message,
                severity: "error",
              });
            } else {
              showNotification({
                msg: savemsg,
              });
              window.location.reload();
            }
          }
        });
      }
    });
  };

  importPopUpClose = () => {
    this.setState({ importPopUpFlag: false });
  };

  dataMethod = (dataObj) => {
    const hasErrorRow = dataObj.some((item) => item.flag == 1);

    this.setState({ validatedProductList: dataObj, hasErrorRow });
  };

  getDynamicColumns = (validatedProductList) => {
    const structures = [];
    const stakeholders = [];

    validatedProductList.map((row) => {
      row.productRateStructDetail.map((rateObj) => {
        const structName = rateObj.productRateStruct?.name;
        if (structName && !structures.includes(structName)) {
          structures.push(structName);
        }

        rateObj.typeWiseRateList.map((rate) => {
          const holderName = rate.stockStakeHolderType?.name?.toUpperCase();
          if (holderName && !stakeholders.includes(holderName)) {
            stakeholders.push(holderName);
          }
        });
      });
    });

    return { structures, stakeholders };
  };

  render() {
    const {
      fromDate,
      toDate,
      salesTeam,
      importPopUpFlag,
      validatedProductList,
      hasErrorRow,
    } = this.state;

    const { structures: dynamicColumns, stakeholders: stakeholderColumns } =
      this.getDynamicColumns(validatedProductList);

    return (
      <>
        <Paper
          sx={{
            borderRadius: 2,
            p: { xs: 2, sm: 4 },
            boxShadow: "0 6px 32px rgba(0,0,0,0.08)",
            // background: "linear-gradient(135deg,rgb(251, 251, 251) 0%,rgb(238, 247, 250) 100%)",
            maxWidth: "auto",
            margin: "auto",
          }}
          elevation={5}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <LandingScreenHeader
              screenTitle="New Product Creation"
              showSaveBtnMain={false}
              showAddButton={false}
              showBackButton={false}
            />

            <div style={{ display: "flex", gap: 15 }}>
              <Button
                variant="outlined"
                color="secondary"
                size="medium"
                startIcon={<CloudDownloadIcon />}
                sx={{
                  borderRadius: 2,
                  textTransform: "none",
                  fontWeight: 600,
                  transition: "all 0.2s",
                  minWidth: "120px",
                  height: "35px",
                  "&:hover": {
                    backgroundColor: "#f4f6fa",
                    borderColor: "#1976d2",
                    color: "#1976d2",
                    transform: "translateY(-2px)",
                  },
                }}
                onClick={this.onClickOfExport}
              >
                Export
              </Button>
              <Button
                variant="contained"
                color="primary"
                size="medium"
                startIcon={<CloudUploadIcon sx={{ color: "#fff" }} />}
                sx={{
                  color: "#fff",
                  borderRadius: 2,
                  textTransform: "none",
                  fontWeight: 600,
                  transition: "all 0.2s",
                  minWidth: "150px",
                  height: "35px",
                  "&:hover": {
                    backgroundColor: "#1976d2",
                    transform: "translateY(-2px)",
                  },
                }}
                onClick={this.onClickOfImport}
              >
                Import
              </Button>
            </div>
          </div>
          <br />
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "5px",
            }}
          >
            {/* Search Box */}
            {validatedProductList.length > 0 && (
              <input
                type="text"
                placeholder="Search..."
                value={this.state.searchValue}
                onChange={this.onSearchBox}
                style={{
                  padding: "6px 10px",
                  fontSize: "14px",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  width: "230px",
                }}
              />
            )}
          </div>
          {/* Updated table JSX with improved scrolling and width management */}
          {validatedProductList.length > 0 && (
            <div style={this.tableStyles.tableWrapper}>
              <table style={this.tableStyles.table}>
                <thead style={this.tableStyles.stickyHeader}>
                  <tr style={this.tableStyles.headerRow}>
                    <th style={{ ...this.tableStyles.headerCell }}>SR No</th>
                    <th style={{ ...this.tableStyles.headerCell }}>
                      Product Name
                    </th>
                    <th style={{ ...this.tableStyles.headerCell }}>
                      Product Code
                    </th>

                    {dynamicColumns.map((structName) => (
                      <>
                        <th style={{ ...this.tableStyles.headerCell }}>
                          Product Rate Struct Name
                        </th>
                        <th style={{ ...this.tableStyles.headerCell }}>
                          Outlet Rate
                        </th>
                        <th style={{ ...this.tableStyles.headerCell }}>MRP</th>
                        <th style={{ ...this.tableStyles.headerCell }}>
                          Expiry Rate
                        </th>
                        {stakeholderColumns.map((holder) => (
                          <th
                            style={{ ...this.tableStyles.headerCell }}
                            key={holder}
                          >
                            {holder}
                          </th>
                        ))}
                      </>
                    ))}

                    <th style={{ ...this.tableStyles.headerCell }}>
                      Error Message
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {validatedProductList.length !== 0 &&
                    this.getFilteredTableData(validatedProductList).map(
                      (row, index) => (
                        <tr
                          key={index}
                          style={{
                            ...this.tableStyles.dataRow,
                            ...this.tableStyles.alternateRow,
                            ...(index % 2 === 0
                              ? this.tableStyles.alternateRow
                              : {}),
                            ...(row.flag == 1 && {
                              backgroundColor: "#ed8e98",
                            }),
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor =
                              this.tableStyles.dataRowHover.backgroundColor;
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor =
                              row.flag == 1
                                ? "#ed8e98"
                                : index % 2 === 0
                                ? this.tableStyles.alternateRow.backgroundColor
                                : this.tableStyles.dataRow.backgroundColor;
                          }}
                        >
                          <td
                            style={{
                              ...this.tableStyles.dataCell,
                              textAlign: "center",
                            }}
                          >
                            {index + 1}
                          </td>
                          <td
                            style={{
                              ...this.tableStyles.dataCell,
                              textAlign: "center",
                            }}
                          >
                            {row.product?.name || "-"}
                          </td>
                          <td
                            style={{
                              ...this.tableStyles.dataCell,
                              textAlign: "center",
                            }}
                          >
                            {row.product?.code || "-"}
                          </td>

                          {dynamicColumns.map((structName) => {
                            const detail = row.productRateStructDetail.find(
                              (d) => d.productRateStruct?.name === structName
                            );

                            const typeWiseRates =
                              detail?.typeWiseRateList || [];

                            return (
                              <>
                                <td
                                  style={{
                                    ...this.tableStyles.dataCell,
                                    textAlign: "center",
                                  }}
                                >
                                  {structName}
                                </td>
                                <td
                                  style={{
                                    ...this.tableStyles.dataCell,
                                    textAlign: "center",
                                  }}
                                >
                                  {detail?.outletRate || "-"}
                                </td>
                                <td
                                  style={{
                                    ...this.tableStyles.dataCell,
                                    textAlign: "center",
                                  }}
                                >
                                  {detail?.mrp || "-"}
                                </td>
                                <td
                                  style={{
                                    ...this.tableStyles.dataCell,
                                    textAlign: "center",
                                  }}
                                >
                                  {detail?.expiryRate || "-"}
                                </td>
                                {stakeholderColumns.map((holder) => (
                                  <td
                                    key={holder}
                                    style={{
                                      ...this.tableStyles.dataCell,
                                      textAlign: "center",
                                    }}
                                  >
                                    {typeWiseRates.find(
                                      (r) =>
                                        r.stockStakeHolderType?.name?.toUpperCase() ===
                                        holder
                                    )?.rate || "-"}
                                  </td>
                                ))}
                              </>
                            );
                          })}

                          {row.flag == 1 ? (
                            <td
                              style={{
                                ...this.tableStyles.dataCell,
                                minWidth: "200px",
                                textAlign: "left",
                              }}
                            >
                              {row.errorMessage !== null
                                ? row.errorMessage
                                : "-"}
                            </td>
                          ) : (
                            <td
                              style={{
                                ...this.tableStyles.dataCell,
                                minWidth: "200px",
                                textAlign: "center",
                              }}
                            >
                              {"-"}
                            </td>
                          )}
                        </tr>
                      )
                    )}
                </tbody>
              </table>
            </div>
          )}

          {validatedProductList.length !== 0 && !hasErrorRow && (
            <>
              <Grid
                item
                sm={12}
                xs={12}
                md={12}
                lg={12}
                rowSpacing={2}
                columnSpacing={{ xs: 12, sm: 6, md: 1 }}
                container
                justifyContent="right"
                sx={{ marginTop: 3 }}
              >
                <ButtonCompo
                  size="medium"
                  type="submit"
                  variant="contained"
                  name="Submit"
                  onClick={this.onSubmit}
                />
              </Grid>
            </>
          )}

          {importPopUpFlag && (
            <NewProductCreationImportPopUp
              open={importPopUpFlag}
              handleCloses={this.importPopUpClose}
              dataMethod={this.dataMethod}
            />
          )}
        </Paper>
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  salesPersonList: state.salesExecutive,
});

const mapDispatchToProps = {
  showLoador,
  showNotification,
  downloadExcel,
  getSalesExecutiveByUserType,
};
export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(NewProductCreationImportExport);
